import React from "react";
import { useTranslation } from "react-i18next";

interface SummaryTabProps {
  summary: string | undefined;
  resumeUrl: string | undefined;
  isGeneratingSummary: boolean;
  onGenerateSummary: () => void;
}

const SummaryTab: React.FC<SummaryTabProps> = ({
  summary,
  resumeUrl,
  isGeneratingSummary,
  onGenerateSummary,
}) => {
  const { t } = useTranslation(["recruiting", "common"]);

  return (
    <div className="summary-tab">
      <div className="summary-header">
        <h3>{t("candidates.detail.aiGeneratedSummary")}</h3>
        <button
          onClick={onGenerateSummary}
          disabled={isGeneratingSummary}
          className="btn btn-outline"
        >
          {isGeneratingSummary
            ? t("common:loading.generating")
            : t("candidates.detail.generateSummary")}
        </button>
      </div>

      <div className="summary-content">
        {summary ? (
          <p>{summary}</p>
        ) : (
          <p className="no-summary">
            {t("candidates.detail.noSummaryAvailable")}
          </p>
        )}
      </div>

      {resumeUrl && (
        <div className="resume-section">
          <h4>{t("candidates.detail.resume")}</h4>
          <a
            href={resumeUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="resume-link"
          >
            {t("candidates.detail.viewResume")}
          </a>
        </div>
      )}
    </div>
  );
};

export default SummaryTab;
